import React, { useState } from "react";
import { useAlert } from "../../../Context/AlertContext";
import styles from "./styles/NewUser.module.css"
import { encryptText, pbdkf2 } from "../../../Utils/OstreonEncryption";
import config from "../../../config";
import { useEffect } from "react";

const base_url=config.base_url
function NewUser({OnClose}){
    const alert = useAlert()
    const [error, showError]=useState()
    const [otp, setOTP] = useState()
    const [data, setData]=useState({
        "email":"",
        "full_name":"",
        "login_password":"",
        "role":"",
        "user_type":"Employee",
    })
    // useEffect(()=>{
    //     requestOTPsecret()
    // }, [])
    
    const changeData =(field, value)=>{
        console.log(`${field}:${value}`)
        setData({
            ...data, // Copy the old fields
            [field]: value // But override this one
          });
    }
    const requestOTPsecret = () =>{
        fetch(base_url+'admin/generateCode',{
            method: 'POST',
            mode: 'cors',
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-type': 'application/x-www-form-urlencoded',
                'credentials':'include'
            },
            credentials:'include'
            }).then(res=>{
                if (res.status!==200) throw Error('Error while creating OTP code')
                else return res.json()
            })
            .then((data)=>{
                setOTP(data.code)
            })
            .catch(e=>{
                console.log(e)
                OnClose()
            })
    }
    useEffect(()=>{
        requestOTPsecret()
    }, [])
    const sanitizeData = () =>{
        const isEmpty = Object.values(data).some(x => x == null || x === '');
        console.log(data)
        console.log(isEmpty)
        return isEmpty
    }
    const addUser = async()=>{
        if (sanitizeData()) {showError('Please, fill every field')}
        else{
        var [password_pbdkf2, ] = await pbdkf2(data.login_password, 'OSTREON', 100000, 32*8)
        var otp_secret_encrypted = await encryptText(password_pbdkf2, otp)
        fetch(base_url+'admin/users/add',{
        method: 'POST',
        mode: 'cors',
        headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-type': 'application/x-www-form-urlencoded',
            'credentials':'include'
        },
        body: `email=${data.email}&full_name=${data.full_name}&login_password=${password_pbdkf2}&role=${data.role}&user_type=${data.user_type}&otp_secret=${otp_secret_encrypted}`,
        credentials:'include'
        }).then(res=>res.json())
        .then((data)=>{
        if (data.error) showError(data.error)
        else{
            alert.push("Created!", data.result+"!")
            OnClose()
        }
        })}

    }
    const handleEnter = (e) =>{
        if (e.key==="Enter"){
            addUser()
        }
    }
    return (
        <div className={styles.background} onKeyDown={handleEnter}>
            <div onClick={(e)=>{e.stopPropagation()}} className={styles.main_box} >
                <div  onClick={OnClose} className={styles.close_logo}/>
                <div>
                <div className={styles.title}>Adding New user</div>
                <div className={styles.data_container}>
                    <div className={styles.input_container}>
                        <div className={styles.input_title}>Full Name</div>
                        <input onChange={(e)=>changeData("full_name", e.target.value)} className={styles.input_div} placeholder="Full Name"/>
                    </div>
                    <div className={styles.input_container}>
                        <div className={styles.input_title}>User Type</div>
                        <select defaultValue="Employee" onChange={(e)=>changeData("user_type", e.target.value)} className={styles.input_div} placeholder="Full Name">
                        <option value="Employee">Employee</option>
                        <option value="Administrator">Administrator</option>
                        </select>
                    </div>
                    <div className={styles.input_container}>
                        <div className={styles.input_title}>Email Address</div>
                        <input onChange={(e)=>changeData("email", e.target.value)} className={styles.input_div} placeholder="Email"/>
                    </div>
                    <div className={styles.input_container}>
                        <div className={styles.input_title}>Role</div>
                        <input onChange={(e)=>changeData("role", e.target.value)} className={styles.input_div} placeholder="Role"/>
                    </div>
                    <div className={styles.input_container}>
                        <div className={styles.input_title}>Initial Password</div>
                        <input onChange={(e)=>changeData("login_password", e.target.value)} type="password" className={styles.input_div} placeholder="Password"/>
                    </div>
                    <div className={styles.input_container} style={{visibility:"hidden"}}>
                        <div className={styles.input_title}>Initial Password</div>
                        <input className={styles.input_div} placeholder="Full Name"/>
                    </div>
                </div>
                
                </div>
                <div>{otp?otp:"Loading OTP..."}</div>
                <div onClick={addUser} className={styles.greenbutton}>Create User</div>
                {error&&<div className={styles.error_message}>{error}</div>}
            </div>
        </div>
    )

}
export {NewUser};